import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { hmrBootstrap } from './hmr';

if (environment.production) {
  enableProdMode();
}

// Cleanup: unregister any legacy Angular Service Worker still installed in
// users' browsers. The SW is no longer built/shipped (it intercepted Firebase
// Auth requests with stale cached HTML and broke re-auth on reload).
if ('serviceWorker' in navigator) {
  navigator.serviceWorker
    .getRegistrations()
    .then((regs) => regs.forEach((reg) => reg.unregister()))
    .catch(() => {});
}

// Quill 2.0.3 serializes every single space as &nbsp; in getSemanticHTML()
// (https://github.com/slab/quill/issues/4509). PrimeNG's <p-editor> reads the
// ngModel HTML through that method, so every saved note came back &nbsp;-riddled
// (no line wrapping, plain-space LIKE searches broken). Patch the prototype
// once at startup; dynamic import keeps quill out of the initial bundle.
import('quill').then(({ default: Quill }) => {
  const originalGetSemanticHTML = Quill.prototype.getSemanticHTML;
  Quill.prototype.getSemanticHTML = function (...args: unknown[]): string {
    return (originalGetSemanticHTML as (...a: unknown[]) => string)
      .apply(this, args)
      .replace(/&nbsp;/g, ' ');
  } as typeof originalGetSemanticHTML;
});

// Google Maps (Places) — loaded per-environment from environment.googleMapsApiKey
// instead of a hardcoded <script> in index.html, so each env uses its own
// referrer-restricted key (GT3-APP-{DEV,STAGING,PROD}). Mirrors the previous
// async, best-effort load (loading=async&libraries=places&language=en-US).
if (environment.googleMapsApiKey) {
  const mapsScript = document.createElement('script');
  mapsScript.src =
    'https://maps.google.com/maps/api/js' +
    `?key=${environment.googleMapsApiKey}` +
    '&loading=async&libraries=places&language=en-US';
  mapsScript.async = true;
  mapsScript.defer = true;
  document.head.appendChild(mapsScript);
}

const bootstrap = () => platformBrowserDynamic().bootstrapModule(AppModule);

if (environment.hmr) {
  if (module['hot']) {
    hmrBootstrap(module, bootstrap);
  } else {
    console.error('HMR is not enabled for webpack-dev-server!');
  }
} else {
  bootstrap().catch((err) => console.error(err));
}
